import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BoxNewsInEvidenceComponent} from './box-news-in-evidence/box-news-in-evidence.component';
import {BoxCatalogComponent} from './box-catalog/box-catalog.component';
import {PipesModule} from '../providers/pipes/pipes.module';
import {ModalsModule} from '../components/modals/modals.module';
import {BoxValueComponent} from './box-value/box-value.component';
import {BoxTeamComponent} from './box-team/box-team.component';
import {BoxProductComponent} from './box-product/box-product.component';
import {
  BoxTechnicalSpecificationsComponent
} from './box-technical-specifications/box-technical-specifications.component';
import {BoxAccessoryComponent} from './box-accessory/box-accessory.component';
import {BoxKitComponent} from './box-kit/box-kit.component';
import {LocalizeRouterModule} from '@gilsdav/ngx-translate-router';
import {DirectivesModule} from '../providers/directives/directives.module';
import {RouterModule} from '@angular/router';
import {WidgetsModule} from '../widgets/widgets.module';
import {BoxKitModelComponent} from './box-kit-model/box-kit-model.component';
import {BoxMachineComponent} from './box-machine/box-machine.component';
import {BoxPlaceComponent} from './box-place/box-place.component';
import {BoxEquipmentComponent} from './box-equipment/box-equipment.component';
import {TranslateModule} from '@ngx-translate/core';
import {BoxProductModelComponent} from './box-product-model/box-product-model.component';
import {BoxNewsPrimaryComponent} from './box-news-primary/box-news-primary.component';
import {BoxNewsRelatedComponent} from './box-news-related/box-news-related.component';
import {BoxNewsDefaultComponent} from './box-news-default/box-news-default.component';
import {BoxPlacesByCountryComponent} from './box-places-by-country/box-places-by-country.component';
import { BoxPlaceInfoComponent } from './box-places-by-country/box-place-info/box-place-info.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

@NgModule({
  declarations: [
    BoxNewsInEvidenceComponent,
    BoxCatalogComponent,
    BoxValueComponent,
    BoxTeamComponent,
    BoxProductComponent,
    BoxTechnicalSpecificationsComponent,
    BoxAccessoryComponent,
    BoxKitComponent,
    BoxKitModelComponent,
    BoxMachineComponent,
    BoxPlaceComponent,
    BoxEquipmentComponent,
    BoxProductModelComponent,
    BoxNewsPrimaryComponent,
    BoxNewsRelatedComponent,
    BoxNewsDefaultComponent,
    BoxPlacesByCountryComponent,
    BoxPlaceInfoComponent
  ],
  exports: [
    BoxNewsInEvidenceComponent,
    BoxCatalogComponent,
    BoxValueComponent,
    BoxTeamComponent,
    BoxProductComponent,
    BoxTechnicalSpecificationsComponent,
    BoxAccessoryComponent,
    BoxKitComponent,
    BoxKitModelComponent,
    BoxMachineComponent,
    BoxPlaceComponent,
    BoxEquipmentComponent,
    BoxProductModelComponent,
    BoxNewsPrimaryComponent,
    BoxNewsRelatedComponent,
    BoxNewsDefaultComponent,
    BoxPlacesByCountryComponent
  ],
  imports: [
    CommonModule,
    PipesModule,
    ModalsModule,
    LocalizeRouterModule,
    DirectivesModule,
    RouterModule,
    WidgetsModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class BoxesModule {
}
